import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WithOnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackViewedOnboardingSource.meta';

export type ViewedOnboardingSourceParams = WithOnboardingAnalyticsCategory;

export const useTrackViewedOnboardingSource = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedOnboardingSource = useCallback(
    (params: ViewedOnboardingSourceParams) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackViewedOnboardingSource };
};
